import { FormattedMessage } from 'react-intl'
import { shallowEqual, useSelector } from 'react-redux'

import { CostBreakdownRow } from '@components/UI/CostBreakdown'
import { IApplicationState } from '@store/index'
import {
  ISubmission,
  selectSubTotalCents,
  selectSubTotalCurrency,
  selectTaxDisplayName,
} from '@store/submissions'

interface IProps {
  submission: ISubmission
  showCurrency?: boolean
}

const SubmissionCostBreakdownSocialTotalPrice: React.FC<IProps> = ({
  submission,
  showCurrency,
}) => {
  const { amount, currency, taxDisplayName } = useSelector((state: IApplicationState) => ({
    amount: selectSubTotalCents(state, submission.id),
    currency: selectSubTotalCurrency(state, submission.id),
    taxDisplayName: selectTaxDisplayName(state, submission.id),
  }), shallowEqual)

  return (
    <CostBreakdownRow
      label={
        <FormattedMessage
          id="core.text.totalCurrencyExTaxName"
          values={{
            taxName: taxDisplayName,
            currency: showCurrency ? currency : '',
          }}
        />
      }
      medium
      labelWidth={9}
      currency={currency!}
      quantity={amount!}
    />
  )
}

export default SubmissionCostBreakdownSocialTotalPrice
